var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-my-md row-group"},[_c('div',{staticClass:"container"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_vm._l((_vm.rows),function(row,i){return _c('v-row',{key:i,attrs:{"is-video":_vm.isVideo,"title":row.title,"uri":row.uri,"layout":row.layout,"items":row.items}})})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48c86d30","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/front/RowGroup.vue
// module id = G6KF
// module chunks = 54